'use client';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { Routes } from '@/config/routes';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from '@headlessui/react';
import {
  EllipsisHorizontalIcon,
  PencilIcon,
  ViewfinderCircleIcon,
  TrashIcon,
} from '@heroicons/react/24/solid';

interface MenuItemProps {
  onClick?: (action: string) => void;
}

const dropdown = ['edit', 'preview', 'delete'];
export default function DotsDropdown({ onClick, row }: MenuItemProps) {
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const burl = process.env.NEXT_PUBLIC_API;
  const handleClick = async (action: string, rentalId?: number) => {
    if (action === 'delete' && rentalId) {
      setShowModal(true);
      setDeleteId(rentalId);
    } else if (action === 'preview') {
      router.push(`${Routes.public.listing}/${rentalId}`);
    } else if (action === 'edit') {
      router.push(`${Routes.public.addListing}?rentalId=${rentalId}`);
    } else if (onClick) {
      onClick(action);
    }
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      const response = await fetch(`${burl}/deleterental.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ rentalid: deleteId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Delete Response:', data);
    } catch (error) {
      console.error('Error deleting rental:', error);
    }

    setShowModal(false);
    setDeleteId(null);
  };

  return (
    <>
      <Menu>
        <MenuButton className="text-gray-dark">
          <EllipsisHorizontalIcon className="h-auto w-5" />
        </MenuButton>
        <MenuItems
          transition
          anchor="bottom end"
          portal={true}
          modal={false}
          className="min-w-36 rounded-lg bg-white z-50 border border-gray-200 p-1 shadow-lg"
        >
          {dropdown.map((item) => (
            <MenuItem
              key={`reservation-${item}`}
              as="button"
              type="button"
              className="flex w-full items-center gap-3 rounded-md py-2 px-3 text-left text-sm capitalize hover:bg-gray-lightest"
              onClick={() => handleClick(item, row.id)} // Replace 123 with actual rental ID
              id={item}
            >
              {item === 'edit' && <PencilIcon className="size-4" />}
              {item === 'preview' && (
                <ViewfinderCircleIcon className="size-4" />
              )}
              {item === 'delete' && <TrashIcon className="size-4" />} {item}
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p>Are you sure you want to delete this rental?</p>
            <div className="flex justify-end mt-4">
              <button
                className="bg-gray-300 px-4 py-2 rounded mr-2"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
